import React, { useCallback, Dispatch, SetStateAction } from "react";
import ImageUploader from "react-images-upload";
import Compress from "browser-image-compression";

import { tokens } from "../../../design/tokens";

interface ImageUploadProps {
  setImgUrl: Dispatch<SetStateAction<string>>;
}

const ImageUpload = ({ setImgUrl }: ImageUploadProps) => {
  const getBase64 = (file: File, options: any): any => {
    return new Promise(function (resolve, reject) {
      Compress(file, options).then((compressedBlob) => {
        const convertedBlobFile = new File([compressedBlob], file.name, {
          type: file.type,
          lastModified: Date.now(),
        });
        const reader = new FileReader();

        reader.readAsDataURL(convertedBlobFile);
        reader.onerror = reject;
        reader.onload = () => {
          resolve(reader.result);
        };
      });
    });
  };

  const handleChange = useCallback(
    (files: File[], pictures: any[]) => {
      const options = {
        maxSizeMB: 1,
        useWebWorker: true,
      };

      getBase64(files[0], options).then((result: any) => {
        // eslint-disable-next-line no-param-reassign
        pictures[0] = result;

        setImgUrl(pictures[0]);
      });
    },
    [setImgUrl]
  );

  /* margin/right não são chutados: são os que fazem o botão centralizar.
     A lib define `.fileUploader { width: 100% }` no próprio CSS
     (node_modules/react-images-upload/index.css), sem prop pra sobrescrever
     esse invólucro externo — só o `.fileContainer` interno, que é este
     objeto. `.fileContainer` já tem `margin: 10px auto` na classe da lib;
     sem SOBRESCREVER com margin, essa centralização própria continua valendo
     e centra o botão dentro do invólucro cheio, que ocupa a mesma largura de
     conteúdo do Container — ou seja, no mesmo eixo do formulário abaixo.
     `right: 40` empurrava o botão pra fora dessa centralização; removido. */
  const containerStyle = {
    background: "rgba(0, 0, 0, 0)",
    width: 150,
    padding: 0,
    boxShadow: "0px 0px 0px #FFFFFF",
  };

  /* A biblioteca só aceita estilo inline, sem acesso ao DOM interno —
     por isso tipografia e cor são o que dá para tokenizar aqui. Era
     "Roboto" cru, sem cor declarada (caía no cinza padrão do navegador). */
  const buttonStyle = {
    background: "rgba(0, 0, 0, 0)",
    fontSize: 14,
    fontFamily: tokens.font.label.family,
    fontWeight: tokens.font.label.weight,
    color: tokens.color.marqueeGold,
    marginTop: 6,
    cursor: "pointer",
  };

  return (
    <ImageUploader
      withIcon={false}
      buttonText="Editar"
      onChange={handleChange}
      imgExtension={[".jpg", ".png"]}
      maxFileSize={5242880}
      withPreview={false}
      withLabel={false}
      singleImage
      fileContainerStyle={containerStyle}
      buttonStyles={buttonStyle}
    />
  );
};

export default ImageUpload;
